import React from 'react';
import useUserSearch from '../../../../hooks/useUserSearch';
import Input from '../../../ui/input';

/**
 * Interface representing the props for the UserHeader component.
 *
 * userCount - The number of users to be displayed in the header.
 * setUserFilter - A function that sets the search bar filter value.
 */
interface UserHeaderProps {
  userCount: number;
  setUserFilter: (search: string) => void;
}

/**
 * UsersListHeader component displays the header section for a list of users.
 * It includes the title and search bar to filter the user.
 * Username search is case-sensitive.
 *
 * @param userCount - The number of users displayed in the header.
 * @param setUserFilter - Function that sets the search bar filter value.
 */
const UsersListHeader = ({ userCount, setUserFilter }: UserHeaderProps) => {
  const { val, handleInputChange } = useUserSearch(setUserFilter);

  return (
    <div className='space-y-4'>
      <div className='flex flex-col md:flex-row justify-between items-center gap-4'>
        <h1 className='text-2xl font-bold'>Users List</h1>
        <Input
          id='user_search_bar'
          placeholder='Search Usernames ...'
          type='text'
          value={val}
          onChange={handleInputChange}
          className='max-w-md w-full'
        />
      </div>
      <div className='flex justify-between items-center'>
        <div id='user_count' className='text-gray-600'>
          {userCount} users
        </div>
      </div>
    </div>
  );
};

export default UsersListHeader;
